// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"f1284f0c","403":"d018f7b9","537":"91c3b1f0","675":"95e62ba8","825":"7d5fd664","942":"fec67105","949":"33af1187","985":"fad83cfa"}[chunkId] + ".css";
};